import { OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceApi, PayeeApi } from '../../shared/sdk/services';
import { Service, PayeeService } from '../../shared/sdk/models';
import { GlobalEventsManager } from '../../events-manager.component';
import { CONSTANT } from '../../shared/app/constants';
var ɵ0 = window;
var ServiceChoiceComponent = /** @class */ (function () {
    function ServiceChoiceComponent(router, userApi, serviceApi, eventsManager) {
        this.router = router;
        this.userApi = userApi;
        this.serviceApi = serviceApi;
        this.eventsManager = eventsManager;
        this.services = new Array();
        this.bmServices = [];
        this.eServices = [];
        this.oServices = [];
        this.SERVICE_DESC = CONSTANT.SERVICE_DESC;
        this.servicesAdded = [];
        this.submitted = [];
    }
    // Initialisation
    ServiceChoiceComponent.prototype.ngOnInit = function () {
        var _this = this;
        window.scroll(0, 0);
        this.eventsManager.loaded(false);
        this.serviceApi.find({ where: { 'deletedAt': null }, order: 'sequence ASC' }).subscribe(function (services) {
            _this.services = services.map(function (elem) {
                return elem;
            });
            _this.bmServices = _this.services.filter(function (service) {
                return service.category == 'Brick & Mortar';
            });
            _this.eServices = _this.services.filter(function (service) {
                return service.category == 'E-Commerce';
            });
            _this.oServices = _this.services.filter(function (service) {
                return service.category == 'Others';
            });
            _this.userApi.getServices(_this.userApi.getCurrentId()).subscribe(function (services) {
                for (var _i = 0, services_1 = services; _i < services_1.length; _i++) {
                    var s = services_1[_i];
                    var service = s;
                    if (service.submission_id) {
                        _this.submitted.push(service.service_id);
                    }
                    else {
                        _this.servicesAdded.push(service.service_id);
                    }
                }
                console.log(_this.servicesAdded.length);
                _this.eventsManager.loaded(true);
                //show pop up when payee is new to portal
                if (_this.servicesAdded.length == 0) {
                    _this.eventsManager.showPopUpImage(null, null);
                }
            });
        }, function (err) {
            if (err.statusCode == 401) {
                _this.eventsManager.popUp('You have been logged in too long. \
            Please enter your login details again to continue using this site.', null);
                _this.eventsManager.logout();
            }
        });
    };
    // Form (services) manipulation methods
    ServiceChoiceComponent.prototype.added = function (service) {
        return this.servicesAdded.indexOf(service.id) > -1;
    };
    ServiceChoiceComponent.prototype.isSubmitted = function (service) {
        return this.submitted.indexOf(service.id) > -1;
    };
    ServiceChoiceComponent.prototype.add = function (service) {
        var id = service.id;
        var i = this.servicesAdded.indexOf(id);
        var j = this.submitted.indexOf(id);
        if (i > -1) {
            // Remove service from selection
            this.servicesAdded.splice(i, 1);
        }
        else if (j < 0) {
            // Add service to selection
            this.servicesAdded.push(id);
        }
    };
    ServiceChoiceComponent.prototype.addServices = function (services) {
        var _this = this;
        services.map(function (service) {
            _this.add(service);
        });
    };
    // Submit service selection
    ServiceChoiceComponent.prototype.confirm = function () {
        var _this = this;
        var data = [];
        this.eventsManager.loaded(false);
        this.userApi.getServices(this.userApi.getCurrentId(), { where: { "submission_id": null } }).subscribe(function (res) {
            var origAddLength = _this.servicesAdded.length;
            if (res.length > 0) {
                for (var _i = 0, res_1 = res; _i < res_1.length; _i++) {
                    var service = res_1[_i];
                    var s = service;
                    var i = _this.servicesAdded.indexOf(s.service_id);
                    if (i > -1) {
                        _this.servicesAdded.splice(i, 1);
                    }
                    else {
                        _this.userApi.destroyByIdServices(_this.userApi.getCurrentId(), s.id).subscribe(function (res) { return console.log(res); });
                    }
                }
            }
            for (var _a = 0, _b = _this.servicesAdded; _a < _b.length; _a++) {
                var s = _b[_a];
                data.push({ "service_id": s, "submission_id": null });
            }
            if (data.length > 0) {
                _this.userApi.createManyServices(_this.userApi.getCurrentId(), data).subscribe(function () {
                    // Navigate to form
                    _this.checkDeclaration();
                }, function (err) {
                    _this.eventsManager.loaded(true);
                    console.log(err);
                });
            }
            else if (origAddLength == 0) {
                _this.eventsManager.loaded(true);
                _this.eventsManager.showPopUp("Please choose at least one service.");
            }
            else {
                _this.checkDeclaration();
            }
        });
    };
    ServiceChoiceComponent.prototype.checkDeclaration = function () {
        this.router.navigate(['/form']);
        // this.userApi.findById(this.userApi.getCurrentId()).subscribe(
        //   res => {
        //     let payee = <Payee> res;
        //     // if (payee.pre_form_declaration) {
        //     //   this.eventsManager.loaded(false);
        //     //   this.router.navigate(['/form']);
        //     // }
        //     // else{
        //     //   this.router.navigate(['/declaration']);
        //     // }
        //     this.router.navigate(['/form']);
        //   }, 
        //   err => {
        //     console.log(err)
        //   }
        // )
    };
    return ServiceChoiceComponent;
}());
export { ServiceChoiceComponent };
export { ɵ0 };
